"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _Summary = _interopRequireDefault(require("./Summary"));
var _Label = _interopRequireDefault(require("./Label"));
var _Error = _interopRequireDefault(require("./Error"));
var _Field = _interopRequireDefault(require("./Field"));
var _Group = _interopRequireDefault(require("./Group"));
var _Hint = _interopRequireDefault(require("./Hint"));
var _Input = _interopRequireDefault(require("./Input"));
var _Select = _interopRequireDefault(require("./Select"));
var _MultiSelect = _interopRequireDefault(require("./MultiSelect"));
require("core-js/es6/promise");
require("core-js/es6/set");
require("core-js/es6/map");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}
var Form = function Form(_a) {
  var initialValues = _a.initialValues,
    onSubmit = _a.onSubmit,
    summary = _a.summary,
    children = _a.children,
    validate = _a.validate,
    validationSchema = _a.validationSchema,
    props = (0, _tslib.__rest)(_a, ["initialValues", "onSubmit", "summary", "children", "validate", "validationSchema"]);
  return _react.default.createElement(_formik.Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    validate: validate,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: validationSchema,
    render: function render(_a) {
      var errors = _a.errors,
        handleSubmit = _a.handleSubmit,
        isValid = _a.isValid,
        values = _a.values;
      return _react.default.createElement("form", (0, _tslib.__assign)({}, props, {
        noValidate: true,
        onSubmit: handleSubmit
      }), Object.keys(errors).length > 0 && summary && _react.default.createElement(_Summary.default, {
        errors: errors
      }), isFunction(children) ? children({
        errors: errors,
        isValid: isValid,
        values: values
      }) : children);
    }
  });
};
Form.displayName = 'Form';
Form.defaultProps = {
  summary: false
};
Form.Label = _Label.default;
Form.Field = _Field.default;
Form.Input = _Input.default;
Form.Group = _Group.default;
Form.Hint = _Hint.default;
Form.Error = _Error.default;
Form.Select = _Select.default;
Form.MultiSelect = _MultiSelect.default;
var _default = Form;
exports.default = _default;